import React, { useState, useEffect, useRef } from "react";
import './Chatbot.css';

function Chatbot({ onClose }) {
  const [question, setQuestion] = useState("");
  // Initialize with a welcome message from Figaro
  const [chatHistory, setChatHistory] = useState([
    { role: "bot", content: "Hello! I'm Figaro, the AI assistant for Digital Fig. How can I help you today?" }
  ]);
  const [loading, setLoading] = useState(false);
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);

  const sendQuestion = async () => {
    if (!question.trim()) return;

    const newHistory = [...chatHistory, { role: "user", content: question }];
    setChatHistory(newHistory);
    setQuestion("");
    setLoading(true);

    try {
      // Send the entire new history to the backend
      const response = await fetch("https://chatbot.k-frederick.workers.dev/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question, history: newHistory })
      });
      const data = await response.json();
      setChatHistory([...newHistory, { role: "bot", content: data.answer }]);
    } catch (error) {
      setChatHistory([...newHistory, { role: "bot", content: "Sorry, something went wrong." }]);
      console.error("Chatbot error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !loading) {
      sendQuestion();
    }
  };

  return (
    <div className="chatbot-modal-overlay" onClick={onClose}>
      <div className="chatbot-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="chatbot-header">
          <h3>Figaro</h3>
          <button onClick={onClose} className="chatbot-close-btn">&times;</button>
        </div>
        <div className="chatbot-history-container" ref={chatContainerRef}>
          {chatHistory.map((msg, index) => (
            <div key={index} className={`chatbot-message ${msg.role}`}>
              <div className="chatbot-message-bubble">{msg.content}</div>
            </div>
          ))}
          {loading && (
            <div className="chatbot-message bot">
              <div className="chatbot-message-bubble">Thinking...</div>
            </div>
          )}
        </div>
        <div className="chatbot-input-area">
          <p className="chatbot-disclaimer">This is an AI chatbot. The information given may not always be complete, up-to-date or reflect the official position or policies of Digital Fig.</p>
          <div className="chatbot-input-wrapper">
            <input
              type="text"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type your question..."
            />
            <button onClick={sendQuestion} disabled={loading || !question}>
              Ask
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chatbot;
